import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const DomainNamespace_AdvisorUIManager = 'Advisor UI Manager';
export const AdvisorUIManagerPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_AdvisorUIManager, defaultUIAccessLevels);
//# sourceMappingURL=advisor-ui-manager.js.map